var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "12" } },
                    [
                      _c(
                        "b-table-simple",
                        {
                          staticClass: "table-inca",
                          attrs: { small: true, "sticky-header": "" },
                        },
                        [
                          _c(
                            "b-thead",
                            [
                              _c(
                                "b-tr",
                                [
                                  _c("b-th", [_vm._v("Email")]),
                                  _c("b-th", [_vm._v("Permission")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-tbody",
                            [
                              _c(
                                "b-tr",
                                [
                                  _c("b-td", [
                                    _vm._v(_vm._s(_vm.item.created_by)),
                                  ]),
                                  _c("b-td", [_vm._v("EDITOR")]),
                                ],
                                1
                              ),
                              _vm._l(_vm.users, function (bt, index) {
                                return _c(
                                  "b-tr",
                                  { key: index },
                                  [
                                    _c("b-td", [_vm._v(_vm._s(bt.applicant))]),
                                    _c("b-td", [_vm._v("VIEWER")]),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }